import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UseCasesSection from './components/UseCasesSection';
import PostaLogistikaSection from './components/PostaLogistikaSection';
import ApproachSection from './components/ApproachSection';
import DifferencesSection from './components/DifferencesSection';
import ConfigurationsSection from './components/ConfigurationsSection';
import PlatformSection from './components/PlatformSection';
import TrustSection from './components/TrustSection';
import ReliabilitySection from './components/ReliabilitySection';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';
import PastsLogistikaPage from './pages/PastsLogistikaPage';

// Homepage component
function HomePage() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCallClick = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App">
      <Header onCtaClick={scrollToContact} onCallClick={handleCallClick} />
      <main>
        <HeroSection onCtaClick={scrollToContact} />
        <UseCasesSection />
        <PostaLogistikaSection />
        <ApproachSection />
        <DifferencesSection />
        <ConfigurationsSection />
        <PlatformSection />
        <TrustSection />
        <ReliabilitySection />
        <div ref={contactRef}>
          <ContactForm />
        </div>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pasts-un-logistika" element={<PastsLogistikaPage />} />
      </Routes>
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;
